import { Component, Input } from '@angular/core';
import { MonitorWithOptions } from 'src/app/pages/area/area.model';
import { BaseAreaMonitorAccordionComponent } from '../base-accordion.component';
import { AccordionService } from 'src/app/services/accordion.service';

@Component({
  selector: 'app-area-monitor-overview',
  templateUrl: './area-monitor-overview.component.html',
  styleUrls: ['./area-monitor-overview.component.scss'],
})
export class AreaMonitorOverviewComponent extends BaseAreaMonitorAccordionComponent {
  @Input() monitor: MonitorWithOptions;
  @Input() visitId: number;
  @Input() date: string;
  @Input() dayNumber: string;
  @Input() areaId: number;
  @Input() isEditingDisabled = false;

  constructor(accordionService: AccordionService) {
    super(accordionService);
  }
}
